export default __webpack_public_path__ + "static/media/obligation.ccee2e07.svg";